var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"height":"95vh"},attrs:{"src":_vm.privacyUrl,"width":"100%","frameborder":"0","allowfullscreen":""}},[_c('p',[_vm._v("Your browser does not support iframes.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }